import { createContext, ReactNode, useContext } from 'react';

export interface ProductPreviewRow {
  title: string;
  imageUrl?: string;
  fieldValues: Record<string, string | null>;
}

export interface ProductPreviewMatch {
  title: string;
  image?: string;
  ean?: string;
  sku?: string;
}

export interface ProductPreviewState {
  products: ProductPreviewRow[];
  matches: Record<string, ProductPreviewMatch>;
  duplicateValues: string[];
  loading: boolean;
  error: string | null;
  hasMore: boolean;
  loadMore: () => void;
  canImport: boolean;
  showNothingToImport: boolean;
}

const ProductPreviewContext = createContext<ProductPreviewState | null>(null);

export function ProductPreviewProvider({ value, children }: { value: ProductPreviewState; children: ReactNode }) {
  return <ProductPreviewContext.Provider value={value}>{children}</ProductPreviewContext.Provider>;
}

export function useProductPreview() {
  return useContext(ProductPreviewContext);
}
